var $cc8167df025acb14$exports = {};
const $cc8167df025acb14$var$btns = document.querySelectorAll(".s-work-btn");
const $cc8167df025acb14$var$portfolio = document.querySelectorAll("[data-type='portfolio']");
const $cc8167df025acb14$var$select = document.querySelector("#work");
const $cc8167df025acb14$var$portfolioItems = document.querySelectorAll('.c-projectBox__item');
let $cc8167df025acb14$var$heightAfter = 0;
let $cc8167df025acb14$var$flag = 0;
let $cc8167df025acb14$var$heightTab = [];
$cc8167df025acb14$var$select.addEventListener("change", ()=>{
    $cc8167df025acb14$var$portfolioItems.forEach((item)=>{
        if (item.classList.contains('c-projectBox')) item.classList.add('hide');
        else item.parentElement.classList.add('hide');
        item.classList.remove('fade-up', 'js-fade-up', 'is-visible');
    });
    if ($cc8167df025acb14$var$select.value === "all") $cc8167df025acb14$var$portfolioItems.forEach((el, index)=>{
        $cc8167df025acb14$var$vissibleElement(el, $cc8167df025acb14$var$heightAfter);
    });
    else $cc8167df025acb14$var$portfolioItems.forEach((el, index)=>{
        if (el.dataset.category === $cc8167df025acb14$var$select.value) $cc8167df025acb14$var$vissibleElement(el);
    });
    $cc8167df025acb14$var$fadeUp();
});
$cc8167df025acb14$var$btns.forEach((btn)=>{
    btn.addEventListener("click", (e)=>{
        $cc8167df025acb14$var$btns.forEach((btn)=>{
            btn.classList.remove("active");
        });
        btn.classList.add("active");
        const category = btn.dataset.category;
        $cc8167df025acb14$var$portfolioItems.forEach((item)=>{
            if (item.classList.contains('c-projectBox')) item.classList.add('hide');
            else item.parentElement.classList.add('hide');
            item.classList.remove('fade-up', 'js-fade-up', 'is-visible');
        });
        if (btn.dataset.category === "all") $cc8167df025acb14$var$portfolioItems.forEach((el, index)=>{
            $cc8167df025acb14$var$vissibleElement(el, $cc8167df025acb14$var$heightAfter);
        });
        else $cc8167df025acb14$var$portfolioItems.forEach((el, index)=>{
            if (el.dataset.category === category) $cc8167df025acb14$var$vissibleElement(el);
        });
        $cc8167df025acb14$var$fadeUp();
    });
}, false);
// //fadeup
function $cc8167df025acb14$var$fadeUp() {
    const items = document.querySelectorAll(".js-fade-up");
    const options = {
        rootMargin: "0px 0px 0px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
function $cc8167df025acb14$var$vissibleElement(e, f) {
    if (e.classList.contains('c-projectBox')) e.classList.remove('hide');
    else e.parentElement.classList.remove('hide');
    e.classList.add('fade-up', 'js-fade-up');
}


//# sourceMappingURL=work.799bce2a.js.map
